import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Category } from '@type/main'
// import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'

const getCategories = (): Promise<Category[]> => {
  return new Promise((resolve, reject) => {
    const URL = routes.CATEGORIES
    // const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${tokenId}`,
    //   },
    // }
    AxiosClient.get(URL)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getCategories
